import styled from 'styled-components'
import { fontWeights, colors, breakpoints } from '@/styles'
import { formatPhone } from '@/utils/format-phone'

const PhoneLink = styled.a`
  font-weight: ${fontWeights.medium};
  font-size: 16px;
  line-height: 24px;
  color: ${colors.link};
  margin: 0;
  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    font-size: 14px;
  }
`

type PhoneLinkProps = { phoneNumber: string; countryCode: string }

const PhoneLinkComponent: React.FC<PhoneLinkProps> = ({ phoneNumber, countryCode }) => {
  const number = formatPhone(phoneNumber, countryCode)
  return <PhoneLink href={`tel:${phoneNumber}`}>{number}</PhoneLink>
}

export default PhoneLinkComponent
